<template>
  <div class="cell-name paragraph-s">
    <div class="mb-1">
      <eg-button
        type="ordinary"
        class="rubric-name-button text-left"
        @click="openRubric"
      >
        {{ item.name || `Rubric #${item.id}` }}
      </eg-button>
    </div>
    <div v-if="item.language" class="language-tags">
      <div class="eg-tag">
        {{ item.language.label || item.language.text }}
      </div>
    </div>
  </div>
</template>

<script>
import { openRubricPreview as showRubricPreview } from "@/components/dashboard/components/open_rubric_preview";
export default {
  name: "CellName",

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  methods: {
    openRubric() {
      showRubricPreview(this.item);
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-name {
  .rubric-name-button {
    padding: 0;
    color: var(--color-text-neutral-on-white, #1c0f30);
    font-weight: inherit;

    &:hover {
      color: var(--color-text-primary-default, #8a3ffc);
      text-decoration: underline;
      background: transparent;
    }

    &:focus {
      box-shadow: none;
    }
  }

  .language-tags {
    font-weight: 400;
  }
}
</style>
